/**
 * Copyright (C) 2018 Egylis,
 * Siège social, 46 rue René Clair, 75892 PARIS cedex 18 - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 14/11/18.
 *
 * Version : Generator 2.0.9
 */

/**
 * Abstract Class for Entity
 */
export abstract class MOEntity {
    /**
     * Uuid
     */
    private _uuid: string;
    /**
     * Status
     */
    private _status: number;
    /**
     * TimeStamp
     */
    private _timeStamp: number;
    /**
     * value of the previous server_id of the same data
     */
    private ___previousServerId: number = -1;
    /**
     * is a new record
     */
    private ___isNew: boolean = true;

    /**
     * Method called before the creation
     */
    protected abstract createBefore(): void;

    /**
     * Method called before the update
     */
    protected abstract updateBefore(): void;

    /**
     * Method called before the synchronization
     */
    protected abstract synchroBefore(): void;

    /**
     * Getter.
     */
    public get uuid(): string {
        return this._uuid;
    }

    /**
     * Setter
     * @param value new value
     */
    public set uuid(value: string) {
        this._uuid = value;
    }

    /**
     * Getter.
     */
    public get status(): number {
        return this._status;
    }

    /**
     * Setter
     * @param value new value
     */
    public set status(value: number) {
        this._status = value;
    }

    /**
     * Getter.
     */
    public get timeStamp(): number {
        return this._timeStamp;
    }

    /**
     * Setter
     * @param value new value
     */
    public set timeStamp(value: number) {
        this._timeStamp = value;
    }

    /**
     * Getter.
     */
    public get __previousServerId(): number {
        return this.___previousServerId;
    }

    /**
     * Setter
     * @param value new value
     */
    public set __previousServerId(value: number) {
        this.___previousServerId = value;
    }

    /**
     * Getter.
     */
    public get __isNew(): boolean {
        return this.___isNew;
    }

    /**
     * Setter
     * @param value new value
     */
    public set __isNew(value: boolean) {
        this.___isNew = value;
    }
}
